import React from 'react';
import NewsPostsComp from './NewsPostsComp';

function NewsPosts() {
  return <NewsPostsComp />;
}

export default NewsPosts;
